(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/view-options/lotto.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/view-options/lotto.js');

'use strict';

svs.numbergames.game.view_options.LOTTO = {
  multiHuxFluxArray: [1, 5, 10],
  withoutJokerText: 'Spela Lotto med Joker om du vill ha en chans på Drömvinsten och Andra Chansen.',
  drawDaysInfoDialog(attachTo) {
    svs.ui.dialog.api.add(new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo,
      type: svs.ui.dialog.type.INFO,
      title: 'Dragning två dagar i veckan!',
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text: 'Du kan bli miljonvinnare både på onsdagar och lördagar. Tänk på att Drömvinsten och Jackpot på Lotto&nbsp1 växer löpande - ' + 'faller de inte ut vid första dragningen - då är de större vid nästa.'
      }]
    }));
  },
  partDrawDialog(attachTo) {
    svs.ui.dialog.api.add(new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo,
      type: svs.ui.dialog.type.INFO,
      title: 'Två dragningar varje onsdag och lördag',
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text: 'Lotto har två dragningar varje onsdag och lördag – Lotto&nbsp1 och Lotto&nbsp2. Du är garanterad minst ' + 'en miljon kr i vinst om du är ensam om att pricka in alla 7 nummer på någon av dragningarna. På Lotto&nbsp1 ' + 'finns det dessutom en jackpot som växer till nästa Lotto&nbsp1 dragning om den inte faller ut.'
      }]
    }));
  },
  jokerInfoDialog(attachTo) {
    const messages = ['Joker är ett tilläggsspel till Lotto där du kan vinna upp till 30 miljoner. Du behöver dessutom spela med Joker för att ha chans på Drömvinsten och Andra Chansen.', 'I Joker gäller det att pricka in 7 siffror i rätt ordningsföljd. Lyckas du med det så blir vinsten 10, 20 eller 30 miljoner – beroende på insatsen.'];
    svs.ui.dialog.api.add(new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo,
      type: svs.ui.dialog.type.INFO,
      title: 'Joker',
      message: messages.map(text => ({
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text
      }))
    }));
  }
};

 })(window);